import loadable from "@loadable/component";
import { useNavigate, useSearchParams } from "react-router-dom";
import APIS from "../constant/EndPoint";
import usePostHook from "../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../Icons/CreateIcon";
import { toast } from "react-toastify";
import { queryClient } from "../router";
import { useState } from "react";
import useTenantGetHook from "../customHooks/useTenantControlGetHook";
import useGetHook from "../customHooks/useGetHook";

const CreatePickupRequestComponent = loadable(
  () => import("../Components/PickupRequest/CreatePickupRequest")
);

const CreatePickupRequest = () => {
  const [searchParams, setSearchParms] = useSearchParams();
  const selectedOrder = searchParams.get("selectedItems")?.split(",");
  const [openAddVehiclePopup, setOpenAddVehiclePopup] = useState(false);
  const [openAddDriverPopup, setOpenAddDriverPopup] = useState(false);
  const [openDeletePopup, setDeletePopup] = useState(false);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["pickup-request"],
    navigateURL: "/",
  });
  const { mutateAsync: removeitems, isPostLoading: isRemoving } = usePostHook({
    queryKey: ["pickup-request-items"],
    navigateURL: "",
  });
  const { mutateAsync: addVehicle, isPostLoading: isVehicleLoading } =
    usePostHook({
      queryKey: ["vehicle"],
      navigateURL: "",
    });
  const { mutateAsync: addDriver, isPostLoading: isDriverLoading } =
    usePostHook({
      queryKey: ["riders"],
      navigateURL: "",
    });
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const handleRemove = async (id: string) => {
    try {
      const url = `${APIS.PICKUPREQUEST}remove-draft-order/`;
      const res = await removeitems({
        url,
        formData: {
          order_ids: [id],
        },
      });
      if (res.status == 200) {
        queryClient.refetchQueries();
        setDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreate = async (setError: any) => {
    if (!selectedOrder) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.PICKUPREQUEST}`;
    let formData = {
      orders: selectedOrder,
      type: "pickup-request",
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  const { data, isLoading: isPermissionListLoading } = useTenantGetHook({
    queryKey: [`permission`],
    url: `${APIS.PERMISSION}`,
    params: {},
  });

  const handleCreatePickup = async (values: any, setError: any) => {
    const url = APIS.PICKUPREQUEST;
    const formData = {
      ...values,
      orders: selectedOrder,
      type: "pickup-request",
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  const handleAddDriver = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER_CREATE}`;
    let formData = {
      ...values,
    };
    try {
      const res = await addDriver({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddDriverPopup(!openAddDriverPopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleAddVehicle = async (values: any, setError: any) => {
    const url = `${APIS.VEHICLE}`;
    let formData = {
      ...values,
      insurance_company_contact_number: values?.insurance_company_contact_number
        ? values?.insurance_company_contact_number.startsWith("+977")
          ? values?.insurance_company_contact_number
          : `+977${values?.insurance_company_contact_number}`
        : null,
      samiti_contact_number: values?.samiti_contact_number
        ? values?.samiti_contact_number.startsWith("+977")
          ? values?.samiti_contact_number
          : `+977${values?.samiti_contact_number}`
        : null,
    };
    try {
      const res = await addVehicle({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddVehiclePopup(!openAddVehiclePopup);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const permissionsLists: any = data && data?.custom_permissions;
  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Pickup Request
        </span>
      </div>
      <CreatePickupRequestComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        handleCreatePickup={handleCreatePickup}
        isRemoving={isRemoving}
        handleRemove={handleRemove}
        openDeletePopup={openDeletePopup}
        handleAddVehicle={handleAddVehicle}
        isVehicleLoading={isVehicleLoading}
        handleAddDriver={handleAddDriver}
        isDriverLoading={isDriverLoading}
        setDeletePopup={setDeletePopup}
        userPermissions={permissionsLists}
        openAddVehiclePopup={openAddVehiclePopup}
        setOpenAddVehiclePopup={setOpenAddVehiclePopup}
        openAddDriverPopup={openAddDriverPopup}
        setOpenAddDriverPopup={setOpenAddDriverPopup}
        profile={profile}
      />
    </div>
  );
};

export default CreatePickupRequest;
